import { UserType } from '../../common/types';
import { getUrlWithId, useGetFetch } from '../../utils/reactQuery';
import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

export type ReminderType = {
  active: boolean;
  date: number;
  objectClass: string;
  objectUuid: string;
  objectInfo: string;
  text: string;
  title: string;
  type: string;
  user: UserType;
  uuid: string;
};

export type FetchRecruitmentRemindersType = {
  count: number;
  results: ReminderType[];
};

export const useGetRecruitmentReminders = (id: string) =>
  useGetFetch<ReminderType[]>({
    url: pathToUrl(getUrlWithId(ApiRoutesEnum.getRecruitment, id).concat('/reminders')),
    config: { enabled: !!id },
  });
